module.exports = __webpack_public_path__ + "static/media/kocka3DM.2386fcc6.png";